import React from 'react';
import {useTranslation} from 'react-i18next';
import {BOOSTER_STEP_DEFS} from '../boosterSteps';

/**
 * El rótulo de un acto: «01 · ALIMENTA».
 *
 * Dice en qué parte del recorrido está la sección que se está leyendo, que es lo que el título no
 * puede decir en una página que se scrollea.
 *
 * **El número es el `order` FIJO del paso**, de `BOOSTER_STEP_DEFS` — la misma definición que
 * dibujan el hilo y el sidebar—, nunca la posición en la página: en nivel MEDIO no hay Revisa y
 * Memoria sigue siendo el 03.
 *
 * Vive suelto y no dentro del encabezado porque los actos lo componen distinto, igual que el
 * mockup: Revisa y Memoria lo ponen **en la misma línea que su título** (`.acto-head` es un flex
 * horizontal), y Alimenta —que abre con el orbe y no lleva encabezado— lo pone abajo, en la fila
 * del instructivo.
 */
export function BoosterActKicker({stepKey, id}) {
    const {t} = useTranslation();
    const def = BOOSTER_STEP_DEFS.find(s => s.key === stepKey);
    if (!def) return null;

    return (
        <span className="iab-flow-kicker" id={id}>
            {def.order !== null && (
                <span className="iab-flow-stepno">{String(def.order).padStart(2, '0')}</span>
            )}
            {t(def.labelKey)}
        </span>
    );
}

export default BoosterActKicker;
